import React, { FC } from 'react';
import { Autocomplete, Box, FormLabel, TextField, Typography } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import styles from './CustomAutoSelect.module.scss';

interface CustomAutoSelectProps {
  options: {name: string}[];
  customClass?: string;
  inputLabel: string;
  handleChange: (event: React.SyntheticEvent<Element, Event>, value: { name: string } | null) => void;
  onInputChange: (event: any, inputValue: any) => void;
  value?: {name: string} | null;
  placeholder?: string;
}

const CustomAutoSelect: FC<CustomAutoSelectProps> = ({ 
  options,
  customClass,
  inputLabel,
  handleChange,
  value,
  onInputChange,
  placeholder,
}) => {
  return (
    <Box id={styles.customSelectContainer} className={customClass}>
      <FormLabel className={styles.customSelectLabel}>
        <Typography variant='h11Semibold'>{inputLabel}</Typography>
      </FormLabel>
      <Autocomplete
        disablePortal
        options={options}
        onChange={handleChange}
        onInputChange={onInputChange}
        className={styles.customInput}
        popupIcon={<ExpandMoreIcon />}
        value={value}
        getOptionLabel={(option: { name: string }) => option.name}
        isOptionEqualToValue={(option, value) => option.name === value.name}
        sx={{ width: 300 }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            InputLabelProps={{ shrink: false }}
          />
        )}
      />
    </Box>
  );
};

export default CustomAutoSelect;
